import React from "react";
import { Box } from "@mui/material";
import { Outlet, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";

import LandingBackground from "../../components/Landing/LandingBackground";
import Sidebar from "../../components/Sidebar";
import { handleNavigate } from "../../utils/navigateUtils";
import { auth } from "../../firebase/firebase";

const StudentLayout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (err) {
      console.error("Student logout failed:", err);
    }
  };

  return (
    <Box sx={{ position: "relative", height: "100vh", overflow: "hidden" }}>
      <LandingBackground />

      <Box
        sx={{
          display: "flex",
          position: "relative",
          zIndex: 2,
          height: "100vh",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Sidebar
          role="student"
          onNavigate={(key) => handleNavigate(key, navigate, "student")}
          onLogout={handleLogout}
        />

        <Box
          sx={{
            flexGrow: 1,
            minWidth: 0,
            p: 4,
            overflowY: "auto",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default StudentLayout;
